// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8013 ? "18b16e15" : chunkId) + "." + {"1013":"d26d6da55f6c1aaf","8013":"2a1acb43624bdccc"}[chunkId] + ".js";
};